import { partners } from "../data/siteContent";

export default function HomePartners() {
  return (
    <section className="ags-section pt-0">
      <div className="container">
        <div className="ags-surface-panel" data-aos="fade-up">
          <div className="row align-items-end mb-4">
            <div className="col-lg-7">
              <p className="ags-section-kicker mb-3">Our Partners</p>
            </div>
          </div>
          <div className="row g-3">
            {partners.map((partner, index) => (
              <div
                className="col-6 col-md-4 col-xl-3"
                key={partner.alt}
                data-aos="zoom-in-up"
                data-aos-delay={index * 40}
              >
                <div className="ags-partner-card">
                  <img
                    src={partner.image}
                    alt={partner.alt}
                    className="ags-partner-logo"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
